export default __webpack_public_path__ + "assets/homepage_obj.e6ea0c9fdef55e42fa93a31870018e8e.svg";